export default __webpack_public_path__ + "static/media/giphy.8ee75907.jpg";